
    import './styles.scoped.css';
    export default {
  "block-body-scroll": "awsui_block-body-scroll_19d8l_1967j_13",
  "mobile-bar": "awsui_mobile-bar_19d8l_1967j_17",
  "mobile-bar-breadcrumbs": "awsui_mobile-bar-breadcrumbs_19d8l_1967j_30",
  "mobile-toggle": "awsui_mobile-toggle_19d8l_1967j_37",
  "mobile-toggle-type-navigation": "awsui_mobile-toggle-type-navigation_19d8l_1967j_46",
  "mobile-toggle-type-tools": "awsui_mobile-toggle-type-tools_19d8l_1967j_49",
  "mobile-toggle-type-drawer": "awsui_mobile-toggle-type-drawer_19d8l_1967j_49",
  "drawers-container": "awsui_drawers-container_19d8l_1967j_56"
};
  